import { Subtitle } from 'modules/ui/typography/Typography';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormTitle = styled(Subtitle)`
  margin: 0.688rem 0;

  ${mediaQuery('md')} {
    margin: 1.5rem 0 1rem;
  }
`;
